<template>
    <b-card
        :title="translations.title[lang]"
        :loading="loading"
        :error-message="errorMessage"
        @cancel="$emit('cancel')"
        @submit="
            () => {
                updateReward({
                    item: sendPoints,
                    url: 'flags/reward',
                    commitText: 'storePanel/setSendPoints',
                    successText: 'send points info',
                });
                updateRewardPoints();
            }
        "
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >
        <v-row no-gutters>
            <!-- <v-col cols="auto">
                <v-icon
                    color="secondary"
                    v-text="icons.mdiInformation"
                ></v-icon>
            </v-col> -->

            <v-col cols="12">
                <!-- {{ translations.info[lang] }} -->
                {{ translations.rewardPoints[lang] }}
<v-row >
        <v-col cols="2" class="pl-0 pt-0 pb-6 pr-0 d-inline-flex align-center justify-center">
                    <span>{{ translations.assign[lang] }}</span>
                </v-col>
                <v-col cols="2" class="pl-0 pt-0 pb-6 pr-0">
                    <b-text-field
                        v-model="rewardPoints"
                        :label="translations.points[lang]"
                        no-margin-top
                    ></b-text-field>
                </v-col>
                  <v-col cols="1" class="pl-0 pt-0 pb-6 pr-0 d-inline-flex align-center justify-center">
                    <span>{{ translations.per[lang] }}</span>
                </v-col>

                <v-col cols="2" class="pl-0 pt-0 pb-6 pr-0">
                    <b-text-field
                        v-model="rewardCurrency"
                        :label="translations.currency[lang]"
                        no-margin-top
                    ></b-text-field>
                </v-col>
                
                  <v-col cols="1" class="pl-0 pt-0 pb-6 pr-0 d-inline-flex align-center justify-center">
                    <span>{{ translations.euro[lang] }}</span>
                </v-col>
                <v-col cols="3" class="pl-0 pt-0 pb-6 pr-0">
                    <b-select
                        v-model="rewardRounding"
                        :label="translations.round[lang]"
                        :items="roundingItems"
                        :item-text="`name[${lang}]`"
                        no-clear-icon
                        item-value="value"
                        no-margin-top
                    ></b-select>
                </v-col>
</v-row>

                {{ translations.systemNotification[lang] }}

                <b-select
                    v-model="sendPoints.system_notification_id"
                    :items="systemNotifications"
                    item-text="name"
                    item-value="system_notification_id"
                    :label="translations.notifyConsumers[lang]"
                    class="mb-4"
                ></b-select>

                <v-checkbox
                    v-model="sendPoints.offline_transaction_products"
                    color="secondary"
                    class="pt-0 mt-3"
                    hide-details
                >
                    <template v-slot:label>
                        <h4
                            class="subtitle-2"
                            v-text="translations.selectProducts[lang]"
                        ></h4>
                    </template>
                </v-checkbox>

                <v-checkbox
                    v-model="sendPoints.offline_transaction_receipt"
                    color="secondary"
                    class="pt-0 mt-1 mt-2 "
                    hide-details
                >
                    <template v-slot:label>
                        <h4
                            class="subtitle-2"
                            v-text="translations.receiptCode[lang]"
                        ></h4>
                    </template>
                </v-checkbox>
                <v-checkbox
                    v-if="sendPoints.offline_transaction_receipt"
                    v-model="sendPoints.offline_transaction_receipt_scan"
                    color="secondary"
                    class="pt-0 mt-1 ml-4 mb-2"
                    hide-details
                >
                    <template v-slot:label>
                        <h4
                            class="subtitle-2"
                            v-text="translations.receiptCodeScan[lang]"
                        ></h4>
                    </template>
                </v-checkbox>
                <v-checkbox
                    v-model="sendPoints.offline_two_factor_authentication"
                    color="secondary"
                    class="pt-0 mt-1"
                    hide-details
                >
                    <template v-slot:label>
                        <h4
                            class="subtitle-2"
                            v-text="translations.agreeToTerms[lang]"
                        ></h4>
                    </template>
                </v-checkbox>
            </v-col>
        </v-row>
    </b-card>
</template>

<script>
import { mdiInformation } from "@mdi/js";
import { mapState, mapActions, mapMutations } from "vuex";
import translations from "@/utils/translations/storePanel/settings/reward/sendPoints";

export default {
    name: "SendPoints",

    mixins: [translations],

    data: () => ({
        icons: { mdiInformation },
        sendPoints: {},
        // roundingItems: ['up', 'down']
        roundingItems:[
            {
                name: {
                    el: 'πάνω',
                    en: 'up',
                    it: 'up'
                },
                value: 'up'
            },
            {
                name: {
                    el: 'κάτω',
                    en: 'down',
                    it: 'down'
                },
                value: 'down'
            },
        ]
    }),

    computed: {
        ...mapState(["loading", "errorMessage"]),

        lang() {
            return this.$route.params.lang;
        },

        systemNotifications() {
            return this.$store.state.storePanel.settings.reward
                .systemNotifications;
        },

        rewardPoints: {
            get() {
                return this.$store.state.storePanel.settings.reward.rewardPoints;
            },
            set(val) {
                return this.$store.state.storePanel.settings.reward.rewardPoints=val;
            },
        },

        rewardCurrency: {
            get() {
                return this.$store.state.storePanel.settings.reward.rewardCurrency;
            },
            set(val) {
                return this.$store.state.storePanel.settings.reward.rewardCurrency=val;
            },
        },

        rewardRounding: {
            get() {
                return this.$store.state.storePanel.settings.reward.rewardRounding;
            },
            set(val) {
                return this.$store.state.storePanel.settings.reward.rewardRounding=val;
            },
        },
    },

    methods: {
        ...mapActions("storePanel/settings/reward", [
            "getSystemNotifications",
            "updateReward",
            "getRewardPoints",
            "updateRewardPoints",
        ]),
        ...mapMutations("storePanel/reward", ["setRewardPoints","setRewardCurrency","setRewardRounding"]),
    },

    watch: {
        ["$store.state.storePanel.store"]: {
            immediate: true,
            handler(val) {
                this.sendPoints = {
                    system_notification_id:
                        val.notify_customers.system_notification_id,
                    offline_transaction_products:
                        val.flags.reward.offline_transaction_products,
                    offline_transaction_receipt:
                        val.flags.reward.offline_transaction_receipt,
                    offline_transaction_receipt_scan:
                        val.flags.reward.offline_transaction_receipt_scan,
                    offline_two_factor_authentication:
                        val.flags.reward.offline_two_factor_authentication,
                };
            },
        },
    },

    mounted() {
        this.getSystemNotifications();
        this.getRewardPoints();
    },
};
</script>
